import ChatContainer from './chat-container';

export default ChatContainer;